<span class="navIcon" (click)="toggle()">
	<span class="navThreeLines" [ngClass]="{closeMenu: active}">
		<span class="line top"></span>
		<span class="line middle"></span>
		<span class="line bottom"></span>
	</span>
</span>
